// assets/variant-media-sync.js
(function () {
  function setGalleryForVariant(sectionId, variant) {
    if (!variant || !variant.featured_media) return;
    const key = sectionId + '-' + variant.featured_media.id;

    // Scope to this product section
    const root = document.getElementById('MainProduct-' + sectionId);
    if (!root) return;

    // Prefer clicking the matching thumbnail (Dawn listens for this)
    const thumbBtn = root.querySelector(
      '.thumbnail-list__item[data-target="' + key + '"] button.thumbnail'
    );
    if (thumbBtn) {
      thumbBtn.click();
      return;
    }

    // Fallback: toggle slides directly
    const targetSlide = root.querySelector('.product__media-item[data-media-id="' + key + '"]');
    if (targetSlide) {
      root.querySelectorAll('.product__media-item').forEach(li => {
        const isActive = li === targetSlide;
        li.classList.toggle('is-active', isActive);
        li.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }
  }

  // Handle Dawn's custom events from <variant-selects>
  function onVariantEvent(e) {
    // Works for both "variant:change" (newer) and "variant:changed" (older) names
    const detail = e.detail || {};
    const variant = detail.variant || detail.productVariant;
    const sectionId =
      (detail.sectionId) ||
      (e.target && e.target.closest('[data-section]') && e.target.closest('[data-section]').dataset.section);

    if (!sectionId || !variant) return;
    setGalleryForVariant(sectionId, variant);
  }

  // Bind once, globally (persists through section HTML swaps)
  document.addEventListener('variant:change', onVariantEvent);
  document.addEventListener('variant:changed', onVariantEvent);

  // Safety net: if a theme doesn’t dispatch variant events, watch option changes
  document.addEventListener('change', function (e) {
    const vs = e.target.closest('variant-selects');
    if (!vs) return;

    try {
      // Dawn keeps the current variant on the element instance
      const el = vs;
      const variant = el.currentVariant || (el._currentVariant || null);
      const sectionId = vs.dataset.section;
      if (sectionId && variant) setGalleryForVariant(sectionId, variant);
    } catch (err) {
      // no-op
    }
  });
})();
